<template>
  <p>
    En construcción.
  </p>
</template>

<script>
export default {
  setup() {
    const basePath = process.env.VUE_APP_PUBLIC_PATH;
    return {
      basePath,
    };
  },
  components: {},
};
</script>
